import { render, staticRenderFns } from "./district-admin-form.vue?vue&type=template&id=28bc4824"
import script from "./district-admin-form.vue?vue&type=script&lang=js"
export * from "./district-admin-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports